<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
    <path d="M1.125 12.675V16.875M1.125 16.875H5.325M1.125 16.875L6.375 11.625M16.875 5.325V1.125M16.875 1.125H12.675M16.875 1.125L11.625 6.375" stroke="currentColor" stroke-width="1.65789" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
</template>
